//----------------------------------------------------------------------
import { Helmet } from "react-helmet-async";
import { useMemo } from "react";
import {
  Card,
  Container,
  Typography,
  Button,
  Stack,
  CircularProgress,
} from "@mui/material";

import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import CustomTable from "../components/data-table/CustomDataTable";
import {
  useGetSathiProgramUsersQuery,
  useLazyGetSathiProgramUsersQuery,
} from "../redux/services/sathiProgram.service";
import Scrollbar from "../components/scrollbar";
import Iconify from "../components/iconify";

import Protected from "../protected/Protected";
import { selectAbility } from "../redux/slices/casl.slice";
import useDownloadAll from "../hooks/useDownloadAll";

export default function SathiProgramPage() {
  const ability = useSelector(selectAbility);

  const { handleDownloadAll, isDownloading } = useDownloadAll(
    useLazyGetSathiProgramUsersQuery,
    "SathiProgram",
  );

  const { register, watch, setValue } = useForm({
    defaultValues: {
      userType: "all",
    },
  });

  const handleResetFilter = () => {
    setValue("userType", "all");
  };

  const watchedUserType = watch("userType");

  const queryParams = useMemo(() => {
    const query = {};
    if (watchedUserType) query.userType = watchedUserType;
    return query;
  }, [watchedUserType]);

  return (
    <Protected>
      <Helmet>
        <title>Sathi Program</title>
      </Helmet>

      <Container>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "flex-start", sm: "center" }}
          justifyContent="space-between"
          spacing={2}
          mb={5}
        >
          <Typography variant="h4" gutterBottom>
            Sathi Program
          </Typography>
          <Button
            variant="outlined"
            startIcon={
              isDownloading ? (
                <CircularProgress size={20} />
              ) : (
                <Iconify icon="eva:download-fill" />
              )
            }
            onClick={() => handleDownloadAll(queryParams)}
            disabled={isDownloading}
          >
            Download All
          </Button>
        </Stack>

        <Card>
          <Scrollbar>
            <CustomTable
              canSelect
              useDataQuery={useGetSathiProgramUsersQuery}
              searchLabel="Search Sathi Program..."
              tableName="SathiProgram"
              defaultQueryParams={queryParams}
              searchCols={[
                "contactNumber",
                "name",
                "deviceCode",
                "recipientOrganizationName",
                "senderOrganizationName",
                "sathiProgram",
              ]}
              resetParentForm={handleResetFilter}
            />
          </Scrollbar>
        </Card>
      </Container>
    </Protected>
  );
}
